import { soundManager } from '../../../../../utils/scene/sound/SoundManager';

export default function useCallSound({ sound }) {
  return {
    callSound() {
      soundManager.onPlay(sound ?? 'click');
    },
  };
}
